const currency = Intl.NumberFormat();

export const toCurrency = (value) => currency.format(value);
